import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

class MensajeRetrasoInd extends Component {
    render() { 
        return (
            <Row>
                <Col md ={12} align = "justify" style={{fontSize: 13}}>
                    <div className="custom-alert-danger" style={{padding: 5,}}>
                        No puedes realizar esta petición.
                    </div>
                </Col>
                <Col md={12} className="custom-mt-10" align="justify">
                    Este estudiante presenta un retraso en el pago por lo que no tiene acceso a esta función
                </Col>
            </Row>
        );
    }
}
 
export default MensajeRetrasoInd;


// WEBPACK FOOTER //
// ./src/shared/MensajeRetrasoInd.jsx